import { QueryClient } from '@tanstack/react-query'

// Shared instance so non-React code (e.g. auth store logout) can access the cache
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
})
